import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container container--animation" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "title title--h2" }, " Редактирование задачи ", -1)
const _hoisted_3 = {
  key: 0,
  class: "title title--h2 error"
}

import TaskForm from '@/components/TaskForm.vue';
import LoadingIndicator from '@/components/UI/LoadingIndicator.vue'
import { useStore } from 'vuex';
import { ref } from 'vue';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { Task } from '@/types/task';
import { useRoute } from 'vue-router'
import { useTasks } from '@/hooks/useTasks';

const btnTitle = 'Изменить';

export default /*#__PURE__*/_defineComponent({
  __name: 'EditTask',
  setup(__props) {

const taskModule = createNamespacedHelpers('taskModule');
const state = ref<Task>(null);
const route = useRoute();
const store = useStore();
const { getTaskById, getRouteState } = taskModule.useGetters(['getTaskById', 'getRouteState']);
const { editTask } = taskModule.useActions(['editTask']);
const { setTaskIdToEdit } = taskModule.useMutations(['setTaskIdToEdit']);

setTaskIdToEdit(route.params.taskId);

const { isLoading, isError, getTasksFromDB } = useTasks(state, store);

if (!getRouteState.value) {
  getTasksFromDB();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(isError))
      ? (_openBlock(), _createElementBlock("h2", _hoisted_3, " Произошла ошибка, попробуйте еще раз "))
      : _createCommentVNode("", true),
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(LoadingIndicator, { key: 1 }))
      : (_openBlock(), _createBlock(TaskForm, {
          key: 2,
          "initial-data": {
        id: _unref(getTaskById).id,
        title: _unref(getTaskById).title,
        date: _unref(getTaskById).date,
        importance: _unref(getTaskById).importance,
        access: _unref(getTaskById).access,
        btnTitle: btnTitle
      },
          onEditTask: _unref(editTask)
        }, null, 8, ["initial-data", "onEditTask"]))
  ]))
}
}

})